import { colors } from "./colors";
import { endpoints, assetsRoot } from "config";

export const META_TITLE = "poppi";
export const META_DESCRIPTION =
  "poppi — the prebiotic soda. Bold, bubbly flavor with just a touch of fruit juice and prebiotics to support a healthy gut. Find your flavor and get it delivered.";
export const CANONICAL_URL_BASE = endpoints.web;
// Link-preview (og:image / twitter:image) art: the seven-can lineup shot the
// brand supplied 2026-09-09.
export const META_DEFAULT_OG_IMAGE = `${assetsRoot}/poppi/favicon.png`;
export const PRIMARY_COLOR = colors.magenta;
